import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import BaseBtModal from "../BaseBtModal.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, requiredIf } from "@vuelidate/validators";
import { sendGAEvent } from "@utils/GaEvents";
import { saveSearchFromRequest } from "@services/realEstateAPI";
import { addGenericRequest } from "@services/requestAPI";
import { sendMortgage } from "@services/agencyAPI";
import { updateNewsletterConsent } from "@services/portfolioCustomerAPI";
import { useKeyEnterPressed } from "@wkComposables/useKeyEnterPressed";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseToggle from "@vueEntry/UIKitComponents/BaseToggle.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { mapActions, mapState } from "pinia";
import { defineComponent } from "vue";
import { useModalStore } from "@store/ModalStore";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
//@ts-ignore
import { PHONE_REGEX } from "@utils/RegexUtils";
import { useMetadataStore } from "@wkWebSrc/js/store";
import md5 from "blueimp-md5";
import { useValidator } from "@wkComposables/useValidator";
import { useCommonVars } from "@wkComposables/useCommonVars";
var phoneValidator = helpers.regex(PHONE_REGEX);
export default defineComponent({
  name: "ContactAgencySuccess",
  components: {
    BaseButton,
    BaseBtModal,
    BaseAlert,
    BaseToggle,
    BaseInput
  },
  props: {
    activateReloadCb: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      default: false
    },
    configOptions: {
      type: Object,
      required: true
    },
    data: {
      type: Object
    },
    isContractTypeSale: {
      type: Boolean,
      default: false
    },
    wikicasaNewsUrl: {
      type: String
    },
    isListing: {
      type: Boolean,
      default: false
    },
    reopenAfterLogin: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    franchiseId: {
      type: String,
      default: ""
    }
  },
  emits: ["reopen-after-login", "show-success-request-sent", "show-error-modal", "closed-modal"],
  setup() {
    var {
      enterPressedCb,
      onEnterPressed
    } = useKeyEnterPressed();
    var {
      isValid
    } = useValidator();
    var {
      wkLabels
    } = useCommonVars();
    return {
      v$: useVuelidate(),
      enterPressedCb,
      onEnterPressed,
      isValid,
      wkLabels
    };
  },
  data() {
    return {
      show: false,
      requestData: {
        toggleGeneric: false,
        toggleMortgage: false,
        phone: "",
        name: "",
        toggleSearch: false,
        toggleNews: false
      },
      isLoading: false,
      isValidPhone: null,
      showRequestSentOk: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    showSaveSearch() {
      return this.configOptions ? this.configOptions.showSaveSearch : true;
    },
    showGenericRequest() {
      return this.configOptions ? this.configOptions.showGenericRequest : true;
    },
    isFranchiseToExclude() {
      var franchiseId = Number(this.franchiseId);
      if (isNaN(franchiseId)) return false;
      return franchiseId === 9 || franchiseId === 13 || franchiseId === 58;
    },
    isTecnocasaFranchise() {
      var franchiseId = Number(this.franchiseId);
      if (isNaN(franchiseId)) return false;
      return franchiseId === 8 || franchiseId === 57;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, {
    userEmailFromStore: "email",
    userNameFromStore: "name"
  })), mapState(usePublicUserMenuStore, ["publicUserId"])), mapState(useMetadataStore, ["pageName", "location"])),
  created() {
    this.show = this.showModal;
    this.setLocation("Modale contatta agenzia (step 2)");
    //Pre-compiling the phone field!
    this.requestData.name = this.isUserLogged ? this.userNameFromStore : this.name || "";
    this.requestData.phone = this.data.phone || "";
    this.onEnterPressed(this.submitForm);
  },
  mounted() {
    if (this.reopenAfterLogin) {
      this.requestData.toggleSearch = true;
    }
  },
  methods: Object.assign(Object.assign({
    handleMortgageRequest(data) {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        try {
          if (!this.requestData.toggleMortgage || !((_a = this.data) === null || _a === void 0 ? void 0 : _a.sale)) return;
          var price = Number(data.price.split(".").join(""));
          //The incoming data in provided by the parent modal (ContactAgencyModal) and it can contain the phone number if the phone field has been filled
          //But, if that is not the case, then we have to retrieve the phone number that we got in the current form
          var phone = data.phone || this.requestData.phone;
          var params = {
            name: data.name || this.userNameFromStore,
            email: data.email || this.userEmailFromStore,
            phone,
            reLink: data.canonicalURL,
            realEstateID: data.id,
            rePrice: price,
            tenant: 1
          };
          sendGAEvent("mortgage", {
            event_location: "".concat(this.pageName, " - ").concat(this.location)
          });
          yield sendMortgage(params);
        } catch (err) {
          console.error(err);
        }
      });
    },
    handleSearchRequest(data) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        if (!this.requestData.toggleSearch) return;
        var email = data.email || this.userEmailFromStore;
        var searchBean = {};
        searchBean["macroTypologyId"] = data.macroTypology;
        searchBean["typologyId"] = data.typology;
        searchBean["cityId"] = data.city;
        searchBean["sale"] = data.sale;
        searchBean["rent"] = !data.sale; //TODO: chideere se è sempre così dato che vi è la prop rent...
        var price = parseFloat(data.price.replace(".", ""));
        if (price) {
          searchBean["priceFrom"] = Math.round(price * 0.8);
          searchBean["priceTo"] = Math.round(price * 1.2);
        }
        try {
          sendGAEvent("mail_alert_save", {
            event_location: "".concat(this.pageName, " - ").concat(this.location),
            real_estate_place_id: (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.placeID) !== null && _b !== void 0 ? _b : null
          });
          yield saveSearchFromRequest(email, searchBean);
        } catch (err) {
          var {
            response
          } = err;
          if (response) {
            if (response.status !== 401 && response.status !== 405 && response.status !== 409 && response.status !== 412) {
              console.error(err.message);
              return;
            }
            //Sending the response status, so it can be handled by the parent component
            this.showErrorModal(response.status);
          }
        }
      });
    },
    handleGenericRequest(data) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      return __awaiter(this, void 0, void 0, function* () {
        try {
          if (!this.requestData.toggleGeneric) return;
          sendGAEvent("generic_request_lead", {
            event_location: "".concat(this.pageName, " - ").concat(this.location),
            real_estate_place_id: (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.placeID) !== null && _b !== void 0 ? _b : null,
            real_estate_contract_type: ((_c = this.data) === null || _c === void 0 ? void 0 : _c.rent) ? "rent" : "sale",
            real_estate_typology_name: (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.typologyName) !== null && _e !== void 0 ? _e : null,
            real_estate_typology_id: (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.typology) !== null && _g !== void 0 ? _g : null,
            user_email_hashed: md5(data.email || this.userEmailFromStore),
            user_email: data.email || this.userEmailFromStore,
            user_id: this.publicUserId === -1 ? null : this.publicUserId
          });
          yield addGenericRequest({
            agencyId: data.agencyId,
            realEstateId: data.id || -1,
            name: this.requestData.name || data.name,
            email: data.email,
            typologyId: (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.typology) !== null && _j !== void 0 ? _j : null,
            phone: data.phone || this.requestData.phone,
            notes: data.notes
          });
        } catch (err) {
          console.error(err);
        }
      });
    },
    catchEmittedMortgageToggle(emittedValue) {
      return __awaiter(this, void 0, void 0, function* () {
        setTimeout(() => {
          var _a;
          if (emittedValue) {
            (_a = document.getElementById("phone")) === null || _a === void 0 ? void 0 : _a.focus();
          }
        }, 200);
      });
    },
    checkIfValidPhone() {
      var validPhone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
      this.isValidPhone = validPhone.test(this.requestData.phone);
      return this.isValidPhone;
    },
    handleNewsRequest(data) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!this.requestData.toggleNews) return;
        var email = data.email || this.userEmailFromStore;
        try {
          sendGAEvent("newsletter_subscribe", {
            event_location: "".concat(this.pageName, " - ").concat(this.location)
          });
          yield updateNewsletterConsent(email);
        } catch (err) {
          console.error(err);
        }
      });
    },
    submitForm() {
      return __awaiter(this, void 0, void 0, function* () {
        //We do not want to serve multiple API calls...
        if (this.isLoading) return false;
        this.v$.$touch(); //Touching all fields!
        if (this.v$.$invalid) return false;
        var {
          data
        } = this;
        var promises = Promise.all([this.handleMortgageRequest(data), this.handleSearchRequest(data), this.handleGenericRequest(data), this.handleNewsRequest(data)]);
        try {
          this.isLoading = true;
          yield promises;
        } catch (err) {
          console.error(err);
          return false;
        } finally {
          this.$emit("reopen-after-login", false);
          this.$emit("show-success-request-sent", true);
          this.show = false;
          this.isLoading = false;
        }
        return true;
      });
    },
    showErrorModal(errorCode) {
      this.$emit("show-error-modal");
      return errorCode;
    },
    onClosed() {
      this.$emit("closed-modal");
    },
    openWikiPrivacy() {
      var privacyUrl = "/privacy/#informativa-j";
      window.open(privacyUrl, "_blank", "scrollbars=yes, width=550, height=600");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useMetadataStore, ["setLocation"])),
  validations() {
    return {
      requestData: {
        name: {
          required: requiredIf(() => {
            return this.requestData.toggleMortgage;
          })
        },
        phone: {
          //The required validator is required to activate the red star which marks an input as required!
          required: requiredIf(() => {
            return this.requestData.toggleMortgage;
          }),
          isPhoneValid: phoneNumber => {
            return !this.requestData.toggleMortgage || phoneValidator(phoneNumber);
          }
        }
      }
    };
  }
});